module.exports = __webpack_public_path__ + "media/images/front/icons/logo_jrs-a09b78dec5c281e22eecba7e293c8ae1.png";